import React from 'react';
import PropTypes from 'prop-types';

const TaxFlowChartButton = props => (
  <div className={`col-xs-6 tax-flow-chart-pipe ${props.colClasses}`}>
    <button
      className={`tax-flow-chart-button ${props.buttonClasses}`}
      onClick={props.onClick}
    >
      {props.text}
    </button>
  </div>
);

TaxFlowChartButton.propTypes = {
  colClasses: PropTypes.string.isRequired,
  buttonClasses: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
};

export default TaxFlowChartButton;



// WEBPACK FOOTER //
// ./src-react/TaxFlowChart/components/TaxFlowChartButton.jsx